module.exports = __webpack_public_path__ + "assets/img/组 537@2x.db579914.png";